<template>
    <table style="width:100%;border-top:solid 3px grey;">
        <tr v-for="(property, heading, i) in item" :key="i">
            <td class="object-viewer-cell object-viewer-heading">
                {{heading}}
            </td>
            <td class="object-viewer-cell">
                {{property}}
            </td>
        </tr>
    </table>
    
</template>

<script>

import draggable from 'vuedraggable'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        item: Object,
    },

    computed: {
      
    },

    methods: {

    }
}
</script>

<style scoped>
    .draggable-container {
        border: dotted 2px #ccc!important;
    }
    .object-viewer-cell {
        padding:5px;
        background-color: #eee;
    }
    .object-viewer-heading {
        background-color: #ccc;
        font-weight:bolder;
        width:200px;
    }
</style>




// WEBPACK FOOTER //
// ObjectViewer.vue?96ff8194